<template>
    <el-container >
      <el-main>
        <el-row  justify="space-start" :gutter="20">
          <el-col :span="24">
            <el-card class="box-card">
              <h4 class="card-title">Create a Product</h4>
              <div class="card-content">
                <span>Create a new product, it will not be live. You edit it after creation, and add regional pricing, cert text etc.</span>
                {{ product }}
                <el-form :model="product" :rules="rules" ref="product" label-width="120px">
                <el-form-item label="Name" prop="name">
                  <el-input v-model="product.name"></el-input>  
                </el-form-item>
                <el-form-item  label="Type" prop="type">
                  <el-select v-model="product.type">
                    <el-option label="Online" value="online course"></el-option>
                    <el-option label="Combined" value="combined course"></el-option>
                    <el-option label="Classroom" value="classroom course"></el-option>
                    <el-option label="Download" value="download"></el-option>
                  </el-select>  
                </el-form-item>
                <el-form-item label="Bundle" props="bundle">
                  <el-switch
                    v-model="product.isBundle"
                    active-text="Yes"
                    inactive-text="No"
                    @change="getProducts"
                  ></el-switch>
                </el-form-item>
                <el-form-item v-if="product.isBundle" label="Select Products" prop="bundleProducts">
                  <el-select v-model="product.bundleProducts" multiple class="wide">
                    <el-option v-for="product in products" :key="product.id" :label="product.name" :value="product.id"></el-option>
    
                  </el-select>  
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="createProduct('product')">Create</el-button>
                  <el-button @click="resetForm('product')">Reset</el-button>
                </el-form-item>
                </el-form>
                </div>
                </el-card>
                </el-col>
                </el-row>
                </el-main>
                </el-container>
                </template>
<script>
import gql from "graphql-tag";

export default {

  data() {
    return {
        product:{type:null,isPublic:false},
        products:[],
        rules: {
        name: [
          { required: true, message: "Please add name", trigger: "blur" }
        ],
       type: [
          { required: true, message: 'Please pick a type', trigger: 'focus' }
        ],
        bundleProducts: [
          { required: true, message: 'Please pick a products', trigger: 'blur' }
        ],
       
      }
    }
},
methods: {
    getProducts(value) {
  if(value===false){
    this.product.bundleProducts=[]
  }
         const q =
        gql`query getProducts {
  Product(where: {type: {_in: ["online course", "combined course", "classroom course", "download"]}, isBundle: {_eq: false}, isPublic: {_eq: "1"}}, order_by: {type: asc}) {
    id
    name
  }
}`;
this.$apollo.query({ query: q }).then(response => {
    this.products = response.data.Product;
})

    },
    resetForm(formName) {
      this.product.isBundle=false
      this.$refs[formName].resetFields();
    },
    createProduct(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {

        }
        else {
          this.$notify({
            title: "Error Creating Classroom",
            message: "Please check you have filled in the required fields",
            duration: 0,
            type: "error"
          });
          return false;
        }
      })
    }
}
}
</script>
<style scoped>
.el-select.wide{width:600px}  
.el-select.wide > .el-select__tags{

}
</style>


// WEBPACK FOOTER //
// src/components/Products/Create.vue